(function () {
    $(function () {
        $('body').on('mouseenter click', '.ui-tooltip:not(.tooltipstered)', function(){
            const $root = $(this)
            let tooltipContent = $root.attr('data-tooltip-content')
            const tooltipType = $root.attr('data-tooltip-type')
            const zIndex = $root.attr('data-tooltip-z-index') || 90
    
            // todo расширить возможность вариативности до всего объекта настроек
            if (!tooltipContent) {
                switch (tooltipType) {
                    case 'bonus':
                        tooltipContent = "<p>Начисляем бонусные рубли&nbsp;– можно оплатить до&nbsp;30% следующей покупки.</p><p><a href='/loyalty/' target='_blank'>Подробнее о бонусной системе</a></p>"
                        break;
                    case 'bonus-order':
                        tooltipContent = "<p> Можно оплатить до&nbsp;30% стоимости заказа.</p><p><a href='/loyalty/' target='_blank'>Подробнее о бонусной системе</a></p>"
                        break;
                    case 'inoagent':
                        tooltipContent = "<p>Внесен(а) в реестр иностранных агентов</p>"
                        break;
                }
            }
            
            // без контента не инитим
            if (tooltipContent)
                $root
                    .tooltipster({
                        content: tooltipContent,
                        contentAsHTML: true,
                        delay: 100,
                        debug: false,
                        functionAfter: function(instance, helper) {
                            instance.destroy()
                        },
                        interactive: true,
                        maxWidth: 300,
                        trigger: 'custom',
                        triggerClose: {
                            mouseleave: true,
                            click: true,
                            tap: true
                        },
                        zIndex: zIndex
                    })
                    .tooltipster('open')
        });
    })
}());
